<template>
  <div class="container"
       :style="{background: `url(${bgImg}) no-repeat top center`,backgroundSize: '100% 100%'}">
    <div :class="['content',(platformName&&(platformName==='luobei'))?'content2':'']">
      <div class="top">
        <div class="header">
          <!-- <img alt="logo" class="u-title" src="../../assets/images/login-img/login-title1.png" /> -->
          <div class="title" v-if="platformName&&platformName==='luobei'&&platformType!=='luobei'">萝北县农村土地确权综合应用平台</div>
          <div class="title" v-if="platformName&&platformName==='luobei'&&platformType==='luobei'">萝北县惠农补贴数据认证系统</div>
        </div>
        <div class="desc"></div>
      </div>
      <div class="u-main">
        <component :is="componentName"
                   class="main-content"></component>
      </div>
    </div>
    <global-footer :copyright="copyright" />
  </div>
</template>

<script>
import platformName from '@/utils/platform'
import GlobalFooter from '../common/GlobalFooter'
import Login from './Login'
import img from './img/loginImg.png'
import img1 from './img/login_bg1.jpg'
import img2 from './img/login_bg2.jpg'
import img3 from './img/login_bg3.jpg'
import img4 from './img/login_bg4.jpg'

import img5 from './img/login_bg5.jpg'
export default {
  name: 'Common',
  components: { GlobalFooter, Login },
  data () {
    return {
      componentName: 'Login',
      bgImg: img,
      platformName: platformName,
      platformType: '' // 默认是萝北确权系统 true 则是萝北县惠农补贴数据认证系统

      // platform: '4' // 平台id
      // platform: '',
      // username: '',
      // pwd: ''
    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
      // return '绥化****'
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  created () {
    // 获取路由传参
    this.bgImg = img
    if (this.platformName === 'luobei') {
      this.bgImg = img4
      // // 处理萝北登录
      // let searchUrl = decodeURI(window.location.href).split('?')
      // // if (searchUrl.split('?').length <= 1) return
      // // let param = searchUrl.split('?')[1].split('=')[1]
      // console.log('萝北登录：', searchUrl)
      // // if (param === 'luobei') this.platformType = param
      // if (searchUrl[0].indexOf('luobei') !== -1) {
      //   this.platformType = 'luobei'
      // }
    }

    if (window.location.href && (this.platformName !== 'luobei')) {
      let searchUrl = decodeURI(window.location.href)
      // let params = searchUrl.replace('?params=', '')
      // 无查询参数不继续执行
      if (searchUrl.split('?').length <= 1) return

      let params = searchUrl.split('?')[1].replace('params=', '')
      // let params = window.location.search.replace("?params=", "");
      let passParams = JSON.parse(decodeURIComponent(params))
      let platform = passParams.platform && passParams.platform.toString()
      if (platform.toString() === '1') {
        this.bgImg = img1
      } else if (platform.toString() === '2') {
        this.bgImg = img2
      } else if (platform.toString() === '3') {
        this.bgImg = img3
      } else if (platform.toString() === '5') {
        this.bgImg = img5
      }
      // else if (platform.toString() === '4') {
      //   this.platform = platform.toString()
      //   // 萝北县农村土地确权综合应用平台
      //   this.bgImg = img4
      // } else if (platform.toString() === '5') {
      //   this.platform = platform.toString()
      //   // 萝北县惠农补贴数据认证系统
      //   this.bgImg = img4
      // }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  // background: #fff url("./img/login_bg.jpg") no-repeat top center;
  // background-size: 100% 100%;

  .content {
    padding: 32px 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    @media (min-width: 768px) {
      // padding: 116px 0 10px;
      padding: 0;
    }
    .top {
      text-align: center;
      .header {
        height: 50px;
        line-height: 50px;
        a {
          text-decoration: none;
        }
        .logo {
          width: 40px;
          height: 19px;
          vertical-align: center;
          margin-right: 16px;
        }
        .title {
          font-size: 42px;
          // color: rgba(0, 0, 0, 0.85);
          color: #fff;
          font-family: "Myriad Pro", "Helvetica Neue", Arial, Helvetica,
            sans-serif;
          font-weight: 600;
          position: relative;
          letter-spacing: 6px;
          top: 6px;
        }
      }
      .desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 40px;
      }
    }
    .u-main {
      width: 464px;
      background: rgba(255, 255, 255, 0.45);
      border-radius: 6px;
      padding: 12px;
      margin: 0 60%;
      // box-shadow: 5px 5px 12px #a0a0a0;
    }
    .main-content {
      // width: 368px;
      width: 440px;
      // background: #fff;
      padding: 40px;
      margin: 0 auto;
      @media screen and (max-width: 576px) {
        width: 95%;
      }
      @media screen and (max-width: 320px) {
        .captcha-button {
          font-size: 14px;
        }
      }
    }
  }

  // 萝北登录样式
  .content2 {
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/loginSuihua/Common.vue